import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Row, Col, Button, ButtonToolbar } from 'react-bootstrap';
import ReactDataGrid from 'react-data-grid';
import { Data } from 'react-data-grid-addons';
import { Translate } from 'react-redux-i18n';
import Select from 'react-select';

import ContentWrapper from '../../components/Layout/ContentWrapper';
import { UI_HEIGHT } from '../Common/constants';
import Spinner from '../../components/Widgets/spinner';
import checkPermission from '../Common/permissions';
import ImageFormatter from '../Common/ImageFormatter';
import Category2DisplayOptionsFormatter from './Category2DisplayOptionsFormatter';
import { ROOT_URL, ROOT_API_URL, companyCodeTitle } from '../../actions/root_url';

const isAFG = ROOT_API_URL === 'https://afg-scm.truckxi.com/api/' || ROOT_URL === 'https://afg-scm.truckxi.com/api/';
const isEcity = ROOT_API_URL === 'https://ct-scm.truckxi.com/api/' || ROOT_URL === 'https://ctstage-scm.truckxi.com/api/';
const isAFM =
  ROOT_API_URL === "https://afm-scm.truckxi.com/api/" ||
  ROOT_URL === "https://afm-scm.truckxi.com/api/" ||
  ROOT_API_URL === "https://afmstage-scm.truckxi.com/api/" ||
  ROOT_URL === "https://afmstage-scm.truckxi.com/api/";
  
const {
  Draggable: { Container: DraggableContainer, RowActionsCell, DropTargetRowContainer },
  Data: { Selectors },
} = require('react-data-grid-addons');

const RowRenderer = DropTargetRowContainer(ReactDataGrid.Row);

const propTypes = {
  categories: PropTypes.arrayOf(PropTypes.shape({
    Name: PropTypes.string,
    Description: PropTypes.string,
    Image: PropTypes.string,
    Index: PropTypes.number,
    IsButton: PropTypes.bool,
    IsEnabled: PropTypes.bool,
    IsListView: PropTypes.bool,
    IsMobile: PropTypes.bool,
    ListViewType: PropTypes.string,
    ProductCategory2_id: PropTypes.number,
  })),
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
  ]),
  multiEdited: PropTypes.bool,
  deleteCategorySuccess: PropTypes.bool,
  currentGroup: PropTypes.number,
  categoryIsLoading: PropTypes.bool,
  multiIsEditing: PropTypes.bool,
  savingCategory2Image: PropTypes.bool,
  category2ImageAttached: PropTypes.bool,
  deletingCategory: PropTypes.bool,
  categoryError: PropTypes.string,
  message: PropTypes.string,
  rowKey: PropTypes.string,
  handleCheckBoxClick: PropTypes.func,
  fetchCategories2: PropTypes.func,
  clearCategory2Status: PropTypes.func,
  deleteCategory2: PropTypes.func,
  editMultiCategories2: PropTypes.func,
  fetchCategory2Products: PropTypes.func,
};

const defaultProps = {
  categories: [],
  multiEdited: false,
  deleteCategorySuccess: false,
  currentGroup: null,
  categoryIsLoading: false,
  multiIsEditing: false,
  savingCategory2Image: false,
  category2ImageAttached: false,
  deletingCategory: false,
  categoryError: '',
  message: '',
  rowKey: 'Index',
  value: false,
  handleCheckBoxClick: () => {},
  fetchCategories2: () => {},
  clearCategory2Status: () => {},
  deleteCategory2: () => {},
  editMultiCategories2: () => {},
  fetchCategory2Products: () => {},
};

const contextTypes = {
  router: React.PropTypes.object,
};

class Category_2 extends Component {
  constructor() {
    super();
    this.state = {
      tableHeight: window.innerHeight - UI_HEIGHT.twoLineButton,
      rows: [],
      selectedRows: null,
      editedRows: [],
      filters: {},
      sortColumn: null,
      sortDirection: null,
    };

    this.handleResize = this.handleResize.bind(this);
    this.onDrop = this.onDrop.bind(this);
    this.renderImage = this.renderImage.bind(this);
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    this.props.fetchCategories2();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.categories && nextProps.categories !== this.props.categories) {
      const { categories } = nextProps;
      categories.map((category, index) => {
        category.Index = index;
      });
      this.setState({
        rows: categories,
        selectedRows: null,
        editedRows: [],
      });
    }
    if (nextProps.multiEdited && nextProps.multiEdited !== this.props.multiEdited) {
      this.props.fetchCategories2();
      this.setState({ selectedRows: null, editedRows: [] });
    }
    if (nextProps.deleteCategorySuccess && nextProps.deleteCategorySuccess !== this.props.deleteCategorySuccess) {
      this.props.fetchCategories2();
      this.setState({ selectedRows: null, editedRows: [] });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    this.props.clearCategory2Status();
  }

  onDrop(row, files) {
    if (!files) {
      return;
    }
    const reader = new FileReader();
    reader.onload = () => {
      const index = row.props.rowIdx;
      const newRows = [...this.state.rows];
      const editedRows = [...this.state.editedRows];
      newRows[index].Image = reader.result;
      const editedRowIndex = _.findIndex(editedRows, r => r.Index === row.props.dependentValues.Index);
      if (editedRowIndex === -1) {
        editedRows.push(newRows[index]);
      } else {
        editedRows.splice(editedRowIndex, 1);
        editedRows.push(newRows[index]);
      }
      this.setState({ rows: newRows, editedRows });
    };
    // get the first file and convert to blob object (Blob.slice([start [, end [, contentType]]))
    const blob = files[0].slice(0, files[0].size, files[0].type);
    reader.readAsDataURL(blob);
  }

  onRowValueChange = (event, rowValues, type) => {
    // merge updated row with current row and rerender by setting state
    this.setState({ sortColumn: null, sortDirection: null });
    const rows = JSON.parse(JSON.stringify(this.state.rows));
    const editedRows = this.state.editedRows.slice(0);
    rows[rowValues.Index][type] = event.target.value;
    editedRows.forEach((element, idx) => {
      if (element.Index === rows[rowValues.Index].Index) {
        editedRows.splice(idx, 1);
      }
    }, this);
    // push the row into the editedRows array
    editedRows.push(rows[rowValues.Index]);
    this.setState({
      rows,
      editedRows,
    });
  }

  handleCheckBoxClick = (props, type) => {
    const rows = JSON.parse(JSON.stringify(this.state.rows));
    const index = _.findIndex(rows, { Index: props.dependentValues.Index });
    rows[index][type] = !(rows[index][type]);
    const editedRows = JSON.parse(JSON.stringify(this.state.editedRows));
    editedRows.map((row, idx) => {
      if (row.Index === rows[index].Index) { editedRows.splice(idx, 1); }
    });
    editedRows.push(rows[index]);
    this.setState({ rows, editedRows });
  };

  handleViewTypeSelect = (e, rowValues) => {
    const rows = JSON.parse(JSON.stringify(this.state.rows));
    const index = _.findIndex(rows, { Index: rowValues.Index });
    rows[index].ListViewType = e.value;
    const editedRows = JSON.parse(JSON.stringify(this.state.editedRows));
    editedRows.map((row, idx) => {
      if (row.Index === rows[index].Index) { editedRows.splice(idx, 1); }
    });
    editedRows.push(rows[index]);
    this.setState({ rows, editedRows });
  };

  deleteCategory(e) {
    e.preventDefault();
    const { ProductCategory2_id } = this.state.selectedRows[0];
    if (ProductCategory2_id) {
      this.props.deleteCategory2(ProductCategory2_id);
    } else {
      const rows = JSON.parse(JSON.stringify(this.state.rows));
      const editedRows = JSON.parse(JSON.stringify(this.state.editedRows));
      let index = _.findIndex(rows, { Index: this.state.selectedRows[0].Index });
      rows.splice(index, 1);
      index = _.findIndex(editedRows, { Index: this.state.selectedRows[0].Index });
      editedRows.splice(index, 1);
      rows.map((row, idx) => {
        row.Index = idx;
      });
      this.setState({ rows, editedRows, selectedRows: [] });
    }
  }

  updateRows(e) {
    e.preventDefault();
    let outputRows = [];
    if (this.state.rows && this.state.rows.length > 0) {
      this.state.rows.map(r => {
        if (!r.Name) {
          r.Name = "Banner" + r.Order;
        }
        if (!r.Description) {
          r.Description = "Banner" + r.Order;
        }
        r.Order = Number(r.Order);
        outputRows.push(r);
      });
    }
    outputRows.sort((a, b) => {
      if (a.Order > b.Order) {
        return 1;
      }
      if (a.Order < b.Order) {
        return -1;
      }
      return 0;
    });
    this.props.editMultiCategories2(outputRows);
  }

  handleResize(e) {
    this.setState({ tableHeight: window.innerHeight - UI_HEIGHT.twoLineButton });
  }

  clickNew(e) {
    e.preventDefault();
    const rows = Data.Selectors.getRows(this.state);
    const index = rows.length;
    const newRow = {
      Name: null,
      Description: null,
      IsEnabled: false,
      IsListView: true,
      IsButton: false,
      IsMobile: false,
      ListViewType: 'horizontal-1',
      Index: index,
      ProductGroup_id: this.props.currentGroup,
    };
    rows.push(newRow);
    const editedRows = [...this.state.editedRows];
    editedRows.push(newRow);
    this.setState({ rows, editedRows });
  }

  renderImage(index) {
    const imageFile = (this.state.rows[index].Image || '/img/dummy.png');
    return (
      <div className="product-img-view">
        <img
          src={imageFile}
          alt="Upload"
          className="category2-default-image"
        />
      </div>
    );
  }

  renderTable() {
    if (this.props.categoryIsLoading && !this.props.categoryError) {
      return (
        <Spinner />
      );
    } else if (this.props.categoryError) {
      return (
        <ContentWrapper>
          <div className="alert alert-danger">
            { this.props.categoryError.message }
          </div>
        </ContentWrapper>
      );
    }

    const getRows = () => Data.Selectors.getRows(this.state);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    const handleGridSort = (sortColumn, sortDirection) => {
      const state = Object.assign({}, this.state, { sortColumn, sortDirection });
      this.setState(state);
    };

    const handleFilterChange = (filter) => {
      const newFilters = Object.assign({}, this.state.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      this.setState({ filters: newFilters });
    };

    const handleRowUpdated = (e) => {
      // merge updated row with current row and rerender by setting state
      this.setState({ sortColumn: null, sortDirection: null });
      const rows = getRows();
      const editedRows = this.state.editedRows.slice(0);
      Object.assign(rows[e.rowIdx], e.updated);
      // if the element is already edited, remove the old one.
      editedRows.forEach((element, index) => {
        if (element.Idx === rows[e.rowIdx].Index) { editedRows.splice(index, 1); }
      }, this);
      // push the row into the editedRows array
      editedRows.push(rows[e.rowIdx]);
      this.setState({
        rows,
        editedRows,
      });
    };

    const onRowsSelected = (rows) => {
      const newRows = getRows();
      newRows.map((r) => {
        r.isSelected = false;
      });
      rows.map((r) => {
        newRows[r.rowIdx].isSelected = true;
      });
      this.setState({
        rows: newRows, selectedRows: [rows[0].row],
      }, () => {
        const category2Id = this.state.selectedRows[0].ProductCategory2_id;
        
        let warehouse = localStorage.getItem('warehouseLocation');
        if ((warehouse === null || warehouse === '') && isAFM ) {
          warehouse = 'all';
        }
        if (category2Id) {
          this.props.fetchCategory2Products(category2Id, warehouse);
        }
      });
    };

    const onRowsDeselected = (rows) => {
      const newRows = getRows();
      rows.map((r) => {
        newRows[r.rowIdx].isSelected = false;
      });
      this.setState({ rows: newRows, selectedRows: [] });
    };

    const isDraggedRowSelected = (selectedRows, rowDragSource) => {
      if (selectedRows && selectedRows.length > 0) {
        const key = this.props.rowKey;
        return selectedRows.filter(r => r[key] === rowDragSource.data[key]).length > 0;
      }
      return false;
    };

    const reorderRows = (e) => {
      const selectedRows = Selectors.getSelectedRowsByKey({ rowKey: this.props.rowKey, selectedKeys: [], rows: this.state.rows });
      const draggedRows = isDraggedRowSelected(selectedRows, e.rowSource) ? selectedRows : [e.rowSource.data];
      const undraggedRows = this.state.rows.filter(r => draggedRows.indexOf(r) === -1);
      const args = [e.rowTarget.idx, 0].concat(draggedRows);
      Array.prototype.splice.apply(undraggedRows, args);
      undraggedRows.map((row, index) => {
        row.Index = index;
      });
      this.setState({ rows: undraggedRows, editedRows: undraggedRows });
    };

    const handleIsEnabledClick = (props) => {
      const rows = getRows();
      const index = _.findIndex(rows, { Index: props.dependentValues.Index });
      rows[index].IsEnabled = !(rows[index].IsEnabled);
      const editedRows = [...this.state.editedRows];
      editedRows.map((row, idx) => {
        if (row.Index === rows[index].Index) { editedRows.splice(idx, 1); }
      });
      editedRows.push(rows[index]);
      this.setState({ rows, editedRows });
    };

    const IsEnabledFormatter = React.createClass({
      render() {
        return (
          <input
            id="product-group-enable"
            type="checkbox"
            value="true"
            checked={this.props.value === true || this.props.value === 'true'}
            onClick={() => { handleIsEnabledClick(this.props); }}
          />
        );
      },
    });
    
    const handleIsMobileClick = (props) => {
      const rows = getRows();
      const index = _.findIndex(rows, { Index: props.dependentValues.Index });
      rows[index].IsMobile = !(rows[index].IsMobile);
      const editedRows = [...this.state.editedRows];
      editedRows.map((row, idx) => {
        if (row.Index === rows[index].Index) { editedRows.splice(idx, 1); }
      });
      editedRows.push(rows[index]);
      this.setState({ rows, editedRows });
    };
    
    const IsMobileFormatter = React.createClass({
      render() {
        return (
          <input
            id="product-group-enable"
            type="checkbox"
            value="true"
            checked={this.props.value === true || this.props.value === 'true'}
            onClick={() => { handleIsMobileClick(this.props); }}
          />
        );
      },
    });

    const IdxFormatter = React.createClass({
      render() {
        return (
          <div style={{textAlign: 'center'}}>
            {Number(this.props.dependentValues.Order)}
          </div>
        );
      }
    });

    const handleEnableLaguangeChange = (newVal, dependentValues) => {
      const currentRows = [...this.state.rows];
      currentRows[dependentValues.Index].ViewableLanguages = newVal;
      this.setState({
        rows: currentRows,
      })
    }
    
    const EnabledLanguageFormatter = React.createClass({
      render() {
        const {
          value,
          options,
          dependentValues,
        } = this.props;
        
        const backupOptions = [
          {
            label: 'English - EN',
            value: 'EN',
          },
          {
            label: 'Chinese - ZH',
            value: 'ZH',
          },
        ];
        return (
          <div id="zInd" style={{ position: 'relative', height: '82px' }}>
            <Select
              matchPos={"start"}
              matchProp={'label'}
              menuPortalTarget={document.body}
              styles={{
                // Fixes the overlapping problem of the component
                menu: provided => ({ ...provided, zIndex: 9999 })
              }}
              options={options || backupOptions}
              value={value}
              onChange={newVal => handleEnableLaguangeChange(newVal, dependentValues)}
              multi
              removeSelected
              simpleValue
              closeOnSelect={false}
            />
          </div>
        )
      }
    })

    const columns = [
      {
        key: 'Order',
        name: <Translate value="idx" />,
        resizeable: true,
        width: 50,
        sortable: true,
        editable: true,
        filterable: true,
        formatter: IdxFormatter,
        getRowMetaData: row => row,
      },
      {
        key: 'Category',
        name: <Translate value="category" />,
        resizeable: true,
        width: 220,
        sortable: false,
        editable: false,
        filterable: false,
        formatter: (
          <ImageFormatter
            renderImage={this.renderImage}
            onDrop={this.onDrop}
            onRowValueChange={this.onRowValueChange}
            showImageOnly={false}
          />
        ),
        getRowMetaData: row => row,
      },
      {
        key: 'DisplayOptions',
        name: <Translate value="show_as" />,
        resizeable: true,
        width: 220,
        sortable: false,
        editable: false,
        filterable: false,
        formatter: (
          <Category2DisplayOptionsFormatter
            handleCheckBoxClick={this.handleCheckBoxClick}
            handleViewTypeSelect={this.handleViewTypeSelect}
          />
        ),
        getRowMetaData: row => row,
      },
      {
        key: 'IsEnabled',
        name: <Translate value="enabled" />,
        resizable: true,
        width: 80,
        sortable: false,
        filterable: false,
        formatter: IsEnabledFormatter,
        getRowMetaData: row => row,
      },
      ...isEcity ? [{
        key: 'ViewableLanguages',
        name: <Translate value="enable_for_languages" />,
        resizable: true,
        sortable: true,
        filterable: true,
        formatter: EnabledLanguageFormatter,
        getRowMetaData: (row) => row,
        width: 280,
      }] : {},
      ...isAFM ? [{
        key: 'IsMobile',
        name: <Translate value="mobile" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
        formatter: IsMobileFormatter,
        getRowMetaData: (row) => row,
      } , {
        key: 'ViewableLanguages',
        name: <Translate value="enable_for_languages" />,
        resizable: true,
        sortable: true,
        filterable: true,
        formatter: EnabledLanguageFormatter,
        getRowMetaData: (row) => row,
        width: 280,
      }] : {},
    ];

    return (
      <Row>
        <Col sm={12}>
          <div style={{ maxWidth: '100%' }} id="Category_2-dataGrid1">
            <DraggableContainer>
              <ReactDataGrid
                enableCellSelect
                onGridSort={handleGridSort}
                onAddFilter={handleFilterChange}
                columns={columns}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                minHeight={680}
                rowHeight={200}
                headerRowHeight={25}
                enableRowSelect="single"
                // rowActionsCell={RowActionsCell}
                // rowRenderer={<RowRenderer onRowDrop={reorderRows} />}
                onRowUpdated={handleRowUpdated}
                rowSelection={{
                  showCheckbox: true,
                  onRowsSelected,
                  onRowsDeselected,
                  selectBy: {
                    isSelectedKey: 'isSelected',
                  },
                }}
              />
            </DraggableContainer>
          </div>
        </Col>
      </Row>
    );
  }

  render() {
    return (
      <ContentWrapper>
        <ButtonToolbar className="group-management-table-buttons">
          <Button
            bsStyle="primary"
            className="marginLeftStyle"
            onClick={(event) => { this.clickNew(event); }}
            disabled={!checkPermission('add_product_category')}
          >
            <em className="fa fa-plus marginRightStyle" /><Translate value="create" />
          </Button>
          <Button
            bsStyle="success"
            className="buttonStyle"
            onClick={(event) => { this.updateRows(event); }}
            disabled={!this.state.editedRows || !checkPermission('change_product_category')}
          >
            <em className="fa fa-save marginRightStyle" /><Translate value="save" />
          </Button>
          <Button
            bsStyle="danger"
            className="buttonStyle"
            onClick={(event) => { this.deleteCategory(event); }}
            disabled={!this.state.selectedRows || this.state.selectedRows.length !== 1 || !checkPermission('delete_product_category')}
          ><em className="fa fa-trash marginRightStyle" /><Translate value="delete" />
          </Button>
        </ButtonToolbar>
        {this.renderTable() }
        <br />
        {
          (this.props.multiIsEditing || this.props.savingCategory2Image) &&
          <div className="alert alert-info categories-saving-info">
            <Translate value="saving" />
          </div>
        }
        {
          (this.props.multiEdited || this.props.category2ImageAttached) &&
          <div className="alert alert-success categories-saving-info">
            <Translate value="saved" />
          </div>
        }
        {
          this.props.deletingCategory &&
          <div className="alert alert-info categories-saving-info">
            <Translate value="deleting" />
          </div>
        }
        {
          this.props.deleteCategorySuccess &&
          <div className="alert alert-success categories-saving-info">
            <Translate value="deleted" />
          </div>
        }
      </ContentWrapper>
    );
  }
}

Category_2.propTypes = propTypes;
Category_2.defaultProps = defaultProps;
Category_2.contextTypes = contextTypes;

export default Category_2;



// WEBPACK FOOTER //
// ./master/jsx/components/Products/category_2.jsx